var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnchorLine = function SvgAnchorLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.545 11.1H8v1.8H5.356a7.204 7.204 0 0 0 6.244 6.244v-9.057A3.602 3.602 0 0 1 12.5 3a3.6 3.6 0 0 1 .9 7.087v9.057a7.2 7.2 0 0 0 6.244-6.244H17v-1.8h4.455A9 9 0 0 1 12.5 21a9 9 0 0 1-8.955-9.9M12.5 8.4a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6"
  })));
};
export default SvgAnchorLine;